/**
 * Поздравления победителю матча (MatchWinnerModal): одно выпадает случайно
 * при каждом показе. {name} — никнейм занявшего первое место.
 *
 * Никнейм везде стоит в именительном падеже: ники не склоняются, а «слава
 * Полководец» или «перед shadow_fox_88» читались бы коряво. Глаголы — без рода
 * (настоящее время, безличные обороты), и род не выдают даже существительные
 * вроде «владельца» или «героя»: победитель может быть кем угодно, и
 * «доказал» девушке испортил бы весь триумф.
 */
export const MATCH_WINNER_NAME_PLACEHOLDER = '{name}';

export const MATCH_WINNER_CONGRATULATIONS = [
  '{name} доказывает своё превосходство!',
  '{name} ведёт свою империю к величию!',
  '{name} — сила, которой покорилась эта земля!',
  'Трон мира занимает {name}!',
  'Все короны склонились. Победитель — {name}!',
  'Враги повержены, знамёна подняты — побеждает {name}!',
  '{name} — имя, высеченное в камне истории!',
  '{name} — легенда, о которой сложат песни!',
  'Весь мир запомнит это имя: {name}!',
  'Барабаны войны смолкли. На поле боя остаётся только {name}!',
  '{name} переписывает хроники этого мира!',
  'Мир стал другим — теперь им правит {name}!',
  'Сегодня историю пишет {name}!',
  'Корону по праву носит {name}!',
  'Точный расчёт и железная воля — побеждает {name}!',
  '{name} получает всё: победу и вечную славу!',
  'Крепости пали, ворота распахнуты — входит {name}!',
  'Непревзойдённый стратег — {name}!',
  'Начинается новая эпоха. Её имя — {name}!',
  'Колокола всех городов возвещают: побеждает {name}!',
  'Ни одна армия не устояла — сильнее всех {name}!',
  'Власть. Золото. Слава. Всё забирает {name}!',
  'Величие не даётся — его берут. И берёт его {name}!',
  'Земля дрожит — идёт {name}!',
  'Равных нет. Есть только {name}!',
  'Над полем битвы поднимает знамя {name}!',
];

// Кнопка закрытия — тоже случайная, в тон поздравлению. Без первого лица:
// ее видят и сам победитель, и проигравшие, и зрители
export const MATCH_WINNER_BUTTON_TEXTS = [
  'Слава победителю!',
  'Слава триумфатору!',
  'Достойная победа!',
  'Честь и слава!',
  'Легендарная партия!',
  'Да здравствует победитель!',
  'Браво!',
  'Великая победа!',
  'Достойно!',
  'Виват!',
  'Грамотно!',
];

const pickRandomItem = (items, random) => items[Math.min(items.length - 1, Math.floor(random() * items.length))];

/**
 * Случайное поздравление и текст кнопки. Поздравление разбито на части вокруг
 * никнейма — модалка выделяет никнейм цветом игрока.
 * @param {Function} [random] - источник случайности (Math.random по умолчанию)
 * @returns {{before: string, after: string, buttonText: string}}
 */
export const pickMatchWinnerCongratulation = (random = Math.random) => {
  const template = pickRandomItem(MATCH_WINNER_CONGRATULATIONS, random);
  const [before, after = ''] = template.split(MATCH_WINNER_NAME_PLACEHOLDER);
  return {
    before,
    after,
    buttonText: pickRandomItem(MATCH_WINNER_BUTTON_TEXTS, random),
  };
};
